import { Component } from "@angular/core";
import { NavigationStart, Router } from "@angular/router";
import { MessageService } from "primeng/api";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "../environments/environment";
import { SessionService } from "./common/services/session.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  providers: [MessageService],
})
export class AppComponent {
  title = "fussion-loop";
  isLoggedIn = false;
  todoDisable:boolean = true;
  instanceConfig: any = {};
  supportLanguage = ["en", "mr", "hn"];
  constructor(
    private toast: MessageService,
    private route: Router,
    private ss: SessionService,
    // ---translator--------------------
    private translate: TranslateService
  ) {
    this.routeEvent(this.route);
    // ---------Language--------
    let SelectedLang = localStorage.getItem("selectedLang")
      ? localStorage.getItem("selectedLang")
      : "en";
    this.translate.addLangs(this.supportLanguage);
    this.translate.setDefaultLang(SelectedLang);
    this.translate.use(SelectedLang);
  }

  display: boolean = false;

  showDialog() {
    this.display = true;
  }

  routeEvent(router: Router) {
    router.events.subscribe((e) => {
      if (e instanceof NavigationStart) {
        if (e.url.indexOf("/login") == -1) {
          this.processInstanceConfig();
        }
      }
    });
  }
  private processInstanceConfig() {
    this.instanceConfig = this.ss.getInstanceConfig();
    if (this.instanceConfig) {
      environment.API_BASE = this.instanceConfig.BASE_API;
    }
  }
}
